import React, { useEffect } from 'react'
import './App.css'
import { AppRouter } from './router'
import { store } from './store/store'
import { Provider } from 'react-redux'
import * as Amplify from 'aws-amplify'
import { AwsConfig } from './constants/aws-exports'
import { BrowserRouter } from 'react-router-dom'
import { ConfigProvider } from 'antd'
import heIL from 'antd/lib/locale/he_IL'
import { ThemeProvider } from 'styled-components'
import { theme } from 'styles/theme'
import { cookieService } from 'services/cookie.service'
import { mhfcAuthApiSlice } from 'store/apiSlice'
import { userLogout } from 'store/reducers/userReducer'
import * as Sentry from '@sentry/react'

Amplify.Amplify.configure(AwsConfig)

Sentry.init({
  dsn: process.env.REACT_APP_SENTRY_DSN,

  environment: process.env.REACT_APP_NODE_ENV || 'development',

  enabled: process.env.REACT_APP_NODE_ENV !== 'development',

  // Setting this option to true will send default PII data to Sentry.
  // For example, automatic IP address collection on events
  sendDefaultPii: true,
})

const App: React.FC = () => {
  const dispatch = store.dispatch

  useEffect(() => {
    const clearAllData = async () => {
      try {
        const cacheNames = await caches.keys()
        await Promise.all(cacheNames.map((name) => caches.delete(name)))

        dispatch(mhfcAuthApiSlice.util.resetApiState())
        dispatch(userLogout())

        localStorage.clear()
        sessionStorage.clear()

        cookieService.deleteAllCookies()

        if ('serviceWorker' in navigator) {
          const regs = await navigator.serviceWorker.getRegistrations()
          await Promise.all(regs.map((r) => r.unregister()))
        }
      } catch (err) {
        console.error('Error clearing browser data:', err)
      }
    }
    if (location.pathname === '/') {
      clearAllData()
    }
  }, [dispatch, location.pathname])

  return (
    <ThemeProvider theme={theme}>
      <ConfigProvider direction="rtl" locale={heIL}>
        <Provider store={store}>
          <BrowserRouter>
            <AppRouter />
          </BrowserRouter>
        </Provider>
      </ConfigProvider>
    </ThemeProvider>
  )
}

export default App
